<div [formGroup]="form">

    <app-ativacao-section-card
        [control]="ativoControl"
        titulo="Crédito Presumido IBS"
        [exibirTituloNoAlerta]="false"
        descricaoAtivo="Crédito presumido de IBS ativo. O percentual abaixo será aplicado no cálculo."
        descricaoInativo="Crédito presumido de IBS inativo. Ative para informar o percentual de crédito presumido."
        emptyStateDescricao="Ative o crédito presumido de IBS acima para informar o percentual aplicado no cálculo.">
    </app-ativacao-section-card>

    @if (ativoControl.value) {
    <div class="section-container">
        <div class="section-title">
            <mat-icon class="material-symbols-outlined">hub</mat-icon>
            <span>Crédito Presumido IBS</span>
            <div class="section-title-actions ms-auto">
                <button mat-button type="button" class="btn-section" [matBadge]="personalizadasCount" [matBadgeHidden]="personalizadasCount === 0" (click)="abrirEditorFormulas()">
                    <mat-icon class="material-symbols-outlined">settings</mat-icon>
                    Personalizar fórmulas
                </button>
            </div>
        </div>

        <div class="row g-3">
            <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Crédito Presumido (%)</mat-label>
                    <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pCredPres">
                    <mat-error>{{ form.get('pCredPres')?.hasError('min') ? 'O percentual de crédito presumido do IBS deve estar entre 0 e 100.' : 'Informe o percentual de crédito presumido do IBS.' }}</mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>
    }
</div>
